import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const PressureComboIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBgContainer;

  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55 26.5C58.5899 26.5 61.5 23.5899 61.5 20C61.5 16.4101 58.5899 13.5 55 13.5C51.4101 13.5 48.5 16.4101 48.5 20C48.5 23.5899 51.4101 26.5 55 26.5ZM53.9986 17.6178C54.2913 17.4829 54.6082 17.4081 54.9303 17.398C55.2525 17.3879 55.5734 17.4426 55.874 17.5589C56.0216 17.616 56.1628 17.6874 56.2957 17.7718L55.4385 18.629C55.3021 18.5779 55.1544 18.55 55.0001 18.55C54.3098 18.55 53.7501 19.1096 53.7501 19.8C53.7501 20.4903 54.3098 21.05 55.0001 21.05C55.6905 21.05 56.2501 20.4903 56.2501 19.8C56.2501 19.6318 56.2169 19.4714 56.1567 19.325L58.0602 17.4215C58.2554 17.2263 58.2554 16.9097 58.0602 16.7144C57.8649 16.5192 57.5483 16.5192 57.3531 16.7144L57.015 17.0525C56.7752 16.8773 56.513 16.7339 56.2348 16.6263C55.8093 16.4616 55.355 16.3842 54.8989 16.3985C54.4428 16.4128 53.9943 16.5187 53.5799 16.7097C53.1655 16.9007 52.7938 17.1731 52.4867 17.5106C52.1796 17.848 51.9434 18.2438 51.7923 18.6743C51.6411 19.1048 51.5779 19.5613 51.6066 20.0167C51.6352 20.4721 51.7551 20.9171 51.959 21.3253C52.163 21.7335 52.4469 22.0965 52.7938 22.3928C53.0038 22.5722 53.3194 22.5473 53.4988 22.3374C53.6781 22.1274 53.6533 21.8118 53.4433 21.6324C53.1982 21.4231 52.9977 21.1667 52.8536 20.8783C52.7095 20.59 52.6248 20.2756 52.6046 19.9539C52.5844 19.6323 52.629 19.3098 52.7358 19.0057C52.8426 18.7015 53.0094 18.422 53.2263 18.1836C53.4432 17.9452 53.7059 17.7528 53.9986 17.6178Z"
        fill={currentColor}
      />
    </>
  );
};

export default PressureComboIcon;
